import React from "react";
import { Modal, Box } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAcknowledgmentStatusService } from "../../services/users.services";

const SecurityAdvisoryModal = ({
  open,
  setOpen,
  onContact,
}) => {

  // Update acknowledgment status
  const queryClient = useQueryClient();
  const { mutate: acknowledgeUser, isPending: isUpdating } = useMutation({
    mutationFn: ({ security_status }) =>
      updateAcknowledgmentStatusService({ security_status }),
    onSuccess: (data) => {
      queryClient.invalidateQueries(["acknowledgment-status"]);
      setOpen(false);
    },
    onError: (error) => {
      console.error("Error updating acknowledgment status:", error);
    }
  });

  const handleAcknowledgement = () => {
    acknowledgeUser({ security_status: true });
    console.log("User acknowledged the advisory.");
  }

  return (
    <Modal open={open}>
      <Box
        className="
          absolute top-1/2 left-1/2 
          -translate-x-1/2 -translate-y-1/2 
          bg-white shadow-2xl rounded-2xl 
          w-[90%] max-w-lg p-6 md:p-8
          border border-gray-200
        "
      >
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-yellow-500 text-2xl">⚠️</span>
          <h2 className="text-xl md:text-2xl font-semibold text-gray-900">
            Important Security Advisory
          </h2>
        </div>

        {/* Content */}
        <div className="text-gray-700 space-y-4 text-sm md:text-base">
          <p>
            Please do not make any payments to any personal account for{" "}
            <b>Campus Immersion, Balance Program fees</b>, <b>Study Materials</b>,{" "}
            <b>Alumni fees</b>, or <b>Hotel Bookings</b> based on WhatsApp
            messages, emails, or any other unofficial communication.
          </p>          <p>
            {/* Only trust emails from:{" "}
            <a
              href={`https://mail.google.com/mail/?view=cm&to=academics@accredian.com`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className="font-medium text-gray-900">
                academics@accredian.com
              </span>{" "}
            </a>
            and{" "}
            <a
              href={`https://mail.google.com/mail/?view=cm&to=iimv@accredian.com`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className="font-medium text-gray-900">
                iimv@accredian.com
              </span>
            </a>
            . */}

            Only trust official communications sent from an email address ending in <b>@accredian.com</b>.
          </p>
          <p>
            If you receive any suspicious requests, forward them to <a
              href={`https://mail.google.com/mail/?view=cm&to=academics@accredian.com`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className="font-medium text-gray-900">
                academics@accredian.com
              </span>{" "}
            </a>
            immediately.
          </p>
        </div>

        {/* CTAs */}
        <div className="flex flex-col-reverse md:flex-row gap-3 mt-6">
          <button
            onClick={onContact}
            className="
                flex-[0.5] py-2.5 rounded-xl font-medium 
                border border-gray-300 hover:bg-gray-100 
                transition-colors duration-200
              "
          >
            <a
              href={`https://mail.google.com/mail/?view=cm&to=academics@accredian.com`}
              target='_blank'
              rel='noopener noreferrer'
            >
              Contact Support
            </a>
          </button>
          <button
            onClick={handleAcknowledgement}
            disabled={isUpdating} // prevent double clicks
            className={`flex-[0.5] 
    py-3 px-4 rounded-xl font-semibold flex items-center justify-center gap-2
    transition-colors duration-200
    ${isUpdating ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}
          `}
          >
            {isUpdating && (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
            )}
            {isUpdating ? "Processing..." : "I Acknowledge"}
          </button>
        </div>

        {/* Footer */}
        <p className="mt-6 text-xs text-gray-500 text-center">
          By clicking “I Acknowledge,” you confirm that you have read and
          understood this advisory.
        </p>
      </Box>
    </Modal>
  );
};

export default SecurityAdvisoryModal;
